import { FC, useContext } from "react";

import { AuthContext } from "src/context/authContext";

import { ESCALATION_EMAIL, FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";
import { ContactAndSafetyInfoProps } from "./types";




const ContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor }): JSX.Element => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);

  return (
    <>
      <div className={`${alignText}`}>
        <a className="safety-text btn btn-link p-0" href={
          isUserAuthorized
            ? "https://www.qutenzahcp.com/important-safety-information/?utm_source=MQC&utm_medium=ISIhome&utm_campaign=web"
            : "https://www.qutenza.com/important-safety-information/"
        } target="_blank" rel="noreferrer">
          Important Safety Information
        </a>
        <span> | </span>
        <a className="safety-text btn btn-link p-0" href="https://qutenzahcp.com/pdfs/qutenza_prescribing_information.pdf"
          target="_blank" rel="noreferrer">Full Prescribing Information
        </a>
      </div>
      {isUserAuthorized ? (
        <div className={`${alignText} mt-2`}>
          {isManufacturer ?
            <p className={`d-flex justify-content-center justify-content-md-end flex-wrap text-${textColor}`}>
              Escalation Email: 
              {/* {ESCALATION_EMAIL} */}
              <a 
              className="safety-text" 
              href={`mailto:${ESCALATION_EMAIL}`}
              target="_blank" 
              rel="noreferrer">
                {ESCALATION_EMAIL}
              </a> 
               <span className="mx-1"> | </span>
              <span>Phone: {PHONE_NUMBER} | Fax: {FAX_NUMBER}</span>
            </p>
            :
            <p className={`text-${textColor}`}>
              Phone: {PHONE_NUMBER} | Fax: {FAX_NUMBER}
            </p>}
        </div>
      ) : null}
    </>
  );
};

export default ContactAndSafetyInfo;
//  <a
//                 href={`mailto:${(sub_header as HCPUserSubHeaderProps)["Email:"]}`}
//                 className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline"
//               >
//                 {(sub_header as HCPUserSubHeaderProps)["Email:"]}
//               </a>